import React from "react"
import Headline from "../atoms/Headline"
import Link from "../atoms/Link"
import Richtext from "../atoms/Richtext"

const ChangelogBlock = ({ block }) => {
  return (
    <section className="changelog-block">
      <div className="changelog-block-container">
        <div className="changelog-block-wrapper">
          <div className="row">
            <div className="changelog-block-col-4">
              {block.year?.length > 0 && (
                <div className="changelog-block-date">
                  <p className="changelog-block-date-month">{block.month}</p>
                  <p className="changelog-block-date-year">{block.year}</p>
                </div>
              )}
            </div>
            <div className="changelog-block-col-8">
              <div className="changelog-block-text">
                <Headline
                  kicker={block.kicker}
                  headline={block.headline}
                  subheadline={block.subheadline}
                />
                <Richtext text={block.text} />
                <Link className="btn btn-primary" link={block.link}>
                  <span>
                    <i className={`${block.icon.type} ${block.icon.icon}`}></i>{" "}
                    {block.link_text}
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ChangelogBlock
